module.exports = __webpack_public_path__ + "static/tl-1-ef3f105425f4b1854a338693a56e856b.png";